// CacheKey caf8b6b899d9e727623eac2c9a11b701
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-NCQA": {
    encounters: {
      diagnosis: "Care Gaps"
    }
  }
}

